import { render, staticRenderFns } from "./EmailPanel.vue?vue&type=template&id=5bd7a5dc&scoped=true&"
import script from "./EmailPanel.vue?vue&type=script&lang=js&"
export * from "./EmailPanel.vue?vue&type=script&lang=js&"
import style0 from "./EmailPanel.vue?vue&type=style&index=0&id=5bd7a5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd7a5dc",
  null
  
)

export default component.exports